import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../shared.service';
import * as moment from 'moment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {IAngularMyDpOptions, IMyDateModel} from 'angular-mydatepicker';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {

  myOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: 'dd.mm.yyyy'
  };

  paymentForm: FormGroup;
  customerForm: FormGroup;
  user: any;
  id: string;
  payments: any[];
  emis: any[];
  payment:any;
  recived_amount: number;
  print = false;
  currentUser:any;

  cpFlag = false;

  channelPartners = [] as any;

  constructor(
    private route: ActivatedRoute,
    private SharedService: SharedService,
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {

    this.cpFlag = false;

    this.SharedService.getDelaers().subscribe((data:any)=>{
      data.data.forEach(element => {
        if(element.status === 'active'){
          this.channelPartners.push(element)
        }
      });
      console.log(this.channelPartners);
    })
    this.currentUser = this.SharedService.getUser();
    var myCurrentDate=new Date();
    var myFutureDate=new Date(myCurrentDate);
    myFutureDate.setDate(myFutureDate.getDate()+ 8);
    console.log(myFutureDate);
    let model: IMyDateModel = {isRange: false, singleDate: {jsDate: new Date()}, dateRange: null};
    this.paymentForm = this._formBuilder.group({
      date: [, [Validators.required]],
      ref_number: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      mode: ['cash', [Validators.required]],
      plan: ['', [Validators.required]],
      emi:[[Validators.required]],
      project:[[Validators.required]],
    });

    this.customerForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      contact_1: ['', [Validators.required]],
      contact_2: [''],
      email: ['', [Validators.required]],
      job: ['',[Validators.required]],
      aadhar_no:['',[Validators.required]],
      pan_no:['',[Validators.required]],
      address: ['', [Validators.required]],
      notes: ['']
    });


    this.route.fragment.subscribe((fragment: string) => {
      this.id = fragment;
      this.SharedService.customer(this.id).subscribe((response) => {
        this.user = response.data;
        this.customerForm.patchValue(this.user)
        console.log(this.user);
        this.SharedService.payments(this.user.id).subscribe((data:any)=>{
          this.payments = data.data;
        })
        this.SharedService.emis(this.user.id).subscribe((data:any)=>{
          this.emis = data.data;
        })
      },
        (error) => {
          console.log(error)
        })
    })
  }

  updateCp(event:any){
    console.log(event.value);
    this.cpFlag = true;
    this.SharedService.updateCustomer({channel_partner:event.value},this.id,).subscribe((response) => {
      this.Toast.fire({
        title: 'Done!',
        text: 'Payment has been added',
        icon: 'success'
      })
      this.ngOnInit();
    },
      (error) => {
        console.log(error);
        this.Toast.fire({
          title: 'Error!',
          text: error.error,
          icon: 'error'
        })
      })
  }

  addPayment(emi:any){
    console.log(emi)
    const date: IMyDateModel = {isRange: false, singleDate: {jsDate: new Date(emi.emi_date)}, dateRange: null};
    this.paymentForm.patchValue({
      date,
      amount: emi.emi_amount,
      plan: this.user.payment_plan,
      emi: emi.id,
      project: this.user.property.project
    })
  }

  onEdit(){
    if (this.customerForm.invalid) {
      console.log(this.customerForm.value)
      this.Toast.fire({
        title: 'Error!',
        text: 'All fiedls are required',
        icon: 'error'
      })
      return
    } else {
      this.SharedService.updateCustomer(this.customerForm.value,this.id,).subscribe((response) => {
        console.log(response);
        document.getElementById("editclose").click();
        this.Toast.fire({
          title: 'Done!',
          text: 'Payment has been added',
          icon: 'success'
        })
        this.ngOnInit();
      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error,
            icon: 'error'
          })
        })
    }
  }

  onSubmit(): any {
    if (this.paymentForm.invalid) {
      console.log(this.paymentForm.value)
      this.Toast.fire({
        title: 'Error!',
        text: 'All fiedls are required',
        icon: 'error'
      })
      return
    } else {

      this.paymentForm.patchValue({date:this.paymentForm.value.date.singleDate.jsDate});
      this.SharedService.addPayment(this.id,this.paymentForm.value).subscribe((response) => {
        console.log(response);
        document.getElementById("pclose-btn").click();
        this.Toast.fire({
          title: 'Done!',
          text: 'Payment has been added',
          icon: 'success'
        })
        this.ngOnInit();
      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error,
            icon: 'error'
          })
        })
    }
  }

  delete(id:any):any{
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this payment',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.SharedService.deletePaymet(id).subscribe(response => {
          this.Toast.fire({
            title: 'Deleted!',
            text: 'Payment has been deleted',
            icon: 'success'
          })
          this.ngOnInit();
        },
        (error)=>{
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error,
            icon: 'error',
          });
        })
      }
    })
  }

  receipt(payment:any):any{
    console.log(payment);
    this.payment = payment;
    this.print = true;
  }

  back(){
    this.print = false;
  }


  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

}
